var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news_list"},[_vm._v("消息提醒")])
}
var staticRenderFns = []

export { render, staticRenderFns }